import { render, staticRenderFns } from "./chat-history.vue?vue&type=template&id=350dccc0&scoped=true&"
import script from "./chat-history.vue?vue&type=script&lang=js&"
export * from "./chat-history.vue?vue&type=script&lang=js&"
import style0 from "./chat-history.vue?vue&type=style&index=0&id=350dccc0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "350dccc0",
  null
  
)

export default component.exports